<fui-heading [text]="'Generate Keys'" [level]="5"></fui-heading>
@if (loading) {
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="keygenloader"></myp-inline-loader>
}
@if (!loading) {
  <div class="row">
    <div class="form-group col-md-12">
      <myp-segmented-bar [white]="true" (selected)="selectSection($event.name)" [options]="keyGenerationModes"></myp-segmented-bar>
    </div>
    @if (displayedKeyGenerationMode == "Simple") {
      <div class="form-group col-md-12">
        <small class="text-muted">Product</small>
        <myp-autocomplete-dropdown idName="product" [items]="productTitleArray" (selected)="selectProduct($event)" [selection]="selectedProduct?.title"></myp-autocomplete-dropdown>
      </div>
      @if (selectedProduct && selectedProduct.options && selectedProduct.options.length) {
        <div class="form-group col-md-4">
          <small class="text-muted">Type</small>
          <select class="form-control" name="type" [(ngModel)]="args.productKey.options">
            @for (entry of selectedProduct.options; track entry) {
              <option [ngValue]="entry">{{ entry }}</option>
            }
          </select>
        </div>
      }
    }
    @if (displayedKeyGenerationMode == "Advanced") {
      @if (allProductTitlesWithMetadataArray) {
        <div class="form-group col-md-12">
          <small class="text-muted">Product</small>
          <myp-autocomplete-dropdown idName="advanced" [items]="allProductTitlesWithMetadataArray" (selected)="selectProduct($event)" [selection]="selectedProduct?.title"></myp-autocomplete-dropdown>
        </div>
      }
      @if (selectedProduct) {
        <div class="form-group col-md-4">
          <small class="text-muted">Type</small>
          <select class="form-control" name="type" [(ngModel)]="args.productKey.options">
            @for (entry of productKeyOptions.options | keyvalue; track entry) {
              <option [ngValue]="entry.value">{{ entry.value }}</option>
            }
          </select>
        </div>
      }
    }
    @if (displayedKeyGenerationMode == "Simple" || displayedKeyGenerationMode == "Advanced") {
      @if (selectedProduct) {
        <div class="form-group col-md-4">
          <small class="text-muted"># of Keys</small>
          <input type="number" class="form-control" name="numKeys" id="numKeys" [(ngModel)]="args.numKeys" />
        </div>
      }
      @if (selectedProduct) {
        <div class="form-group col-md-4">
          <small class="text-muted"># of Activations</small>
          <input type="number" class="form-control" name="installCount" id="installCount" [(ngModel)]="args.productKey.installCount" />
        </div>
      }
      @if (args.productKey.options == "OEM") {
        <div class="form-group col-md-4">
          <small class="text-muted">Vendor</small>
          <select class="form-control" name="vendor" [(ngModel)]="args.variant">
            @for (entry of productKeyOptions.oemVariants; track entry) {
              <option [ngValue]="entry">{{ entry }}</option>
            }
          </select>
        </div>
      }
      @if (args.productKey.options == "NFR") {
        <div class="form-group col-md-4">
          <small class="text-muted">Reason</small>
          <select class="form-control" name="reason" [(ngModel)]="args.variant">
            @for (entry of productKeyOptions.nfrVariants; track entry) {
              <option [ngValue]="entry">{{ entry }}</option>
            }
          </select>
        </div>
      }
      @if (selectedProduct) {
        <div class="form-group col-md-12">
          <span class="link" (click)="setExpiration = !setExpiration">
            Set expiration
            <fa-icon [icon]="setExpiration ? 'chevron-down' : 'chevron-right'"></fa-icon>
          </span>
        </div>
      }
      @if (setExpiration) {
        <div class="form-group col-md-4">
          <small class="text-muted">Expiration Date (YYYY-MM-DD)</small>
          <input type="text" class="form-control" name="expirationDate" id="expirationDate" [(ngModel)]="args.expirationDate" />
        </div>
        <div class="form-group col-md-4">
          <small class="text-muted">Or # of days after activation</small>
          <input type="number" class="form-control" name="timeOutDays" id="timeOutDays" [(ngModel)]="args.productKey.timeOutDays" />
        </div>
      }
      @if (displayedKeyGenerationMode == "Advanced") {
        @if (allProductTitlesWithMetadataArray) {
          <div class="form-group col-md-12">
            <small class="text-muted">Bundled Products</small>
            <myp-autocomplete-dropdown
              idName="bundled"
              [items]="allProductTitlesWithMetadataArray"
              [clearOnSelect]="true"
              (selected)="selectBundledProduct($event)"
              [selection]="selectedBundledProduct?.title"
            ></myp-autocomplete-dropdown>
            @if (selectedBundledProducts && selectedBundledProducts.length) {
              <div class="m-t-20">
                @for (item of selectedBundledProducts; track item) {
                  <div>
                    <myp-list-item
                      [item]="item"
                      [includeChevron]="false"
                      [title]="item.title"
                      [imageRound]="false"
                      [photo]="item.imageUrl ? item.imageUrl : false"
                      [showImage]="item.imageUrl ? true : false"
                    >
                      <div class="button-content">
                        <fa-icon icon="times" (click)="removeBundledProduct(item)"></fa-icon>
                      </div>
                    </myp-list-item>
                  </div>
                }
              </div>
            }
          </div>
        }
      }
      <div class="col-12">
        @if (selectedProduct) {
          <button class="btn btn-primary" [disabled]="generating" (click)="generateKeys()">
            @if (generating) {
              <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
            }
            {{ generating ? "Generating Keys..." : "Generate Keys" }}
          </button>
        }
      </div>
    }
    @if (displayedKeyGenerationMode == "Send NFR") {
      <div class="form-group col-md-12">
        <small class="text-muted">Product</small>
        <myp-autocomplete-dropdown idName="NFR" [items]="nfrProductTitleArray" (selected)="selectNfrProduct($event)" [selection]="selectedNfrProduct?.title"></myp-autocomplete-dropdown>
      </div>
      @if (selectedNfrProduct) {
        <div class="form-group col-md-4">
          <small class="text-muted">Reason</small>
          <select class="form-control" name="reason" [(ngModel)]="args.variant">
            @for (entry of productKeyOptions.nfrVariants; track entry) {
              <option [ngValue]="entry">{{ entry }}</option>
            }
          </select>
        </div>
        <div class="form-group col-md-4">
          <small class="text-muted">Name</small>
          <input type="text" class="form-control" name="sendNfrName" id="sendNfrName" [(ngModel)]="sendNfrName" />
        </div>
        <div class="form-group col-md-4">
          <small class="text-muted">Email</small>
          <input type="text" class="form-control" name="sendNfrEmail" id="sendNfrEmail" [(ngModel)]="sendNfrEmail" />
        </div>
        <div class="col-12">
          @if (selectedNfrProduct) {
            <button class="btn btn-primary" [disabled]="generating || !sendNfrName || !sendNfrEmail" (click)="generateKeys()">
              @if (generating) {
                <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
              }
              {{ generating ? "Generating Keys..." : "Generate Keys" }}
            </button>
          }
        </div>
      }
    }
  </div>
}

@if (generatedKeys) {
  @if (displayedKeyGenerationMode != "Send NFR") {
    <h4 class="section-header m-t-20">Your Keys</h4>
  }
  @if (displayedKeyGenerationMode == "Send NFR") {
    <div class="m-t-20">The following key has been sent to {{ sendNfrName }}.</div>
  }
  <div>
    <code>
      @for (key of generatedKeys | slice: 0 : 20; track key) {
        <div>
          {{ key }}
          <span class="pointer" (click)="copyKey(key)">
            <fa-icon icon="copy"></fa-icon>
          </span>
        </div>
      }
      @if (generatedKeys.length > 20) {
        <span>... and {{ generatedKeys.length - 20 }} more. Download the CSV for all the keys.</span>
      }
    </code>
  </div>
  <br />
  @if (displayedKeyGenerationMode != "Send NFR") {
    <span class="btn btn-primary" (click)="downloadKeys()">Download as CSV</span>
  }
}
